module.exports = __webpack_public_path__ + "static/media/fb-icon--red.38a78d7f.svg";